import React, { useContext } from 'react';
import S from "./Allocation.styled";
import CardHeader from "../CardHeader";
import AllocationCircle from './AllocationCircle';
import FundContext from '@/components/FundSingle/FundProvider';
import moment from 'moment';

const Allocation: React.FC<FundSingle> = () => {
    const { portfolio } = useContext(FundContext);
    var date = moment(portfolio?.Date).format('YYYY-MM-DD');

    return (
        <S.AllocationWrapper>
            <CardHeader title="Fördelning" subTitle={date} />
            <S.AllocationBarWrapper>
                <AllocationCircle />
            </S.AllocationBarWrapper>
        </S.AllocationWrapper>
    );
};

export default Allocation;
